import { reducer, on } from "ts-action";
import type { appUser } from "@progressive-development/politik-model";
import { loadProfile, updateProfile } from "./profile-actions.js";

export interface ProfileState {
  profile?: appUser.UserProfile;
}

const initialState: ProfileState = {};

export const profileReducer = reducer<ProfileState>(
  initialState,
  on(loadProfile.success, (state, { payload }) => ({
    ...state,
    profile: payload,
  })),
  on(updateProfile.success, (state, { payload }) => ({
    ...state,
    profile: payload,
  })),
);
